import {graphql} from 'gatsby'
import React from 'react'

import {SliderCards} from '@/sections/slider-cards'

import type {SliderCardsSliceFragment} from '@/graphql-types'

type Props = {
    slice: SliderCardsSliceFragment
}

export const SliderCardsSlice = ({slice}: Props) => {
    const content = slice.primary

    return (
        <SliderCards
            sliderHeading={content.slider_heading}
            highlightFirstCard={content.highlight_first_card}
            hideMediaOnMobile={content.hide_media_on_mobile}
            backgroundColor={content.card_background_color}
            cards={slice.items.map((item) => ({
                ...item,
                itemHeading: item.item_heading,
                subHeading: item.sub_heading,
                subDescription: item.sub_description,
                videoId: item.video_id,
                ctaText: item.cta_text,
                ctaLink: item.cta_link,
            }))}
        />
    )
}

export const sliderCardsSliceFragment = graphql`
    fragment SliderCardsSlice on PrismicSlicePageDataBodySliderCards {
        __typename
        primary {
            slider_heading
            highlight_first_card
            hide_media_on_mobile
            card_background_color
        }
        items {
            item_heading
            sub_heading
            description
            sub_description
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
                gatsbyImageData(breakpoints: $imageBreakpoints, sizes: $twoColumns)
            }
            video_id
            cta_text
            cta_link {
                ...PrismicLink
            }
        }
    }
`
